<template>
    <div class="viewAUDIO">
        <div class="modal-conteudo m-2" v-if="dados">
            <h5 class="bold" v-html="dados.dsDescricao"></h5>
            <audio class="w-100 mt-3" controls :src="dados.urlAudio"></audio>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'viewAUDIO',
        props: {
            dados: Object,
        },
    }
</script>
